import React from 'react'
import Candidate from '../../../features/employerDashboard/components/Candidate/Candidate'

const CandidatePage = () => {
  return (
    <div>
      <Candidate />
    </div>
  )
}

export default CandidatePage
